export default {
  modalMessage: 'Si vous quittez maintenant, vous ne pourrez pas vous connecter à l\'Espace client.',
};
